module.exports = __webpack_public_path__ + "media/images/img-young-ceo-3387ebbff7b3a8d4abd77927fa564135.jpg";